<template>
  <div id="app">
    <router-view v-if="!$route.meta.keepAlive" class="child-view"></router-view>
  </div>
</template>

<script>export default {
  name: 'App',
  components: {
  },
  data() {
    return {

    }
  },
  watch: {
    $route(to, from) {
      if (to.path === '/' || to.path === '/login') {
        this.transitionName = 'slide-right'
      } else {
        this.transitionName = 'slide-left'
      }
    }
  },
  created() {

  },
  computed: {

  },
  mounted() {
    // this.getScreen(1920)
    // window.onresize = () => {
    //   this.getScreen(1920)
    // };
  },
  methods: {
    getScreen(val) {
      let u = navigator.userAgent;
      let zoom = 0;
      zoom = window.innerWidth / val;
      document.getElementsByTagName('body')[0].style.zoom = zoom;
    },
  },
}
</script>

<style lang="scss">
@import './assets/css/base.scss';
@import './assets/css/flexbox.scss';
@import './assets/css/common.scss';

@font-face {
  font-family: 'MyFont';
  src: url('./assets/font/Lexend-Regular.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

.my-font {
  font-family: 'MyFont';
  font-size: 24px;
}

* {
  margin: 0;
  padding: 0;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background: none;
  padding-right: 2px;
}

::-webkit-scrollbar-thumb {
  background: rgba(142, 142, 142, 0.4);
  border-radius: 6px;
}

html,
body,
#app {
  height: 100%;
  color: $color-text-primary;
  font-family: "myFont";
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type='number'] {
  -moz-appearance: textfield;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus {
  -webkit-box-shadow: 0 0 0 1000px rgba(255, 255, 255, 0) inset !important;
  /* -webkit-text-fill-color: #fff; */
  -webkit-transition-delay: 99999s;
  -webkit-transition: color 99999s ease-out, background-color 99999s ease-out;
}

#app {
  position: relative;
}

.child-view {
  width: 100%;
  height: 100%;
  transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
  //overflow: scroll;
}

.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  -webkit-transform: translate(30px, 0);
  transform: translate(30px, 0);
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  -webkit-transform: translate(-30px, 0);
  transform: translate(-30px, 0);
}
</style>

<style lang="scss">
.el-dialog.city-dialog {
  border-radius: 10px;

  .el-dialog__body {
    text-align: center;
    padding: 20px;

    .city-dialog-title {
      font-size: 18px;
      color: #333;
      font-weight: bold;
      margin-bottom: 15px;
    }

    .city-dialog-content {
      font-size: 13px;
      color: #333;
    }
  }

  .el-dialog__footer {
    .city-dialog-btn {
      background: #34C9CB;
      border: #34C9CB;
      width: 120px;
      border-radius: 5px;
    }

    .city-no-open {
      border: none;
      margin-left: 0;
      margin-top: 10px;
      color: #666666;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue